export const challengesDataPolicyandRegulationGuidelines = [
    {
		title: "Limited Spectrum Availability",
		description:
			"Spectrum allocation policies often favor urban and industrial areas, leaving local deployments in rural areas without spectrum. In some countries spectrum for private network deployments is available, but not all.",
		key: "Limited_Spectrum_Availability",
		image: "/images/policies1.png",      
    },
    {
		title: "Long Approvals and Fragmented Policies",
		description:
			"Regulatory approvals related to spectrum allocation and tower construction can delay deployment. In addition, inconsistent policies across regions or even across communities can hinder large-scale rural connectivity initiatives.",
		key: "Long_Approvals",
    },
    {
		title: "Permissions and Law Compliance",
		description:
			"Deploying new telco infrastructure, especially in public space, requires permissions, adequation of spaces and complying with laws.",
		key: "Permissions_Compliance",
    },
];

export const proposalsDataPolicyandRegulationGuidelines = [
    {
		title: "Streamlined Licensing",
		description:
			"Licensing of spectrum and infrastructure construction can be simplified, significantly reducing deployment time.",
		key: "Streamlined_Licensing",
    },
    {
		title: "Encourage Infrastructure Sharing",
		description:
			"Promote policies and setups that support and facilitate the sharing of active and passive infrastructure, and the shared use of radio bands.",
		key: "Encourage_Infrastructure_Sharing",      
    },
    {
		title: "Dynamic Spectrum Sharing (DSS)",
		description:
			"DSS integrates both 4G and 5G on the same spectrum, attempting to use scarce resources effectively. As an alternative, frequencies (e.g. 3.8-4.2GHz) in neighboring to the 5G mid band can be used for local deployments.",
		key: "Dynamic_Spectrum_Sharing",
    },
    {
		title: "Regulator Support",
		description:
			"Support regulators on enabling more 'permitless' environment for small cell antennas, in which telecom operators would be able to install them without going through existing permit systems, as per the EU approved regulations in June 2020 to help facilitate the introduction of small cells.",
		key: "Regulator_Support",      
    },
];

export const challengesDataEconomicAspects = [
    {
		key: "Variety_of_deployment",
		title: "Variety of deployment",
		description:
			"To provide connectivity to rural communities that might cover a variety of sectors and services, the requirements for connectivity and network services might be very different. Deploying a lot of infrastructure to cover all the needs of specific services can be very costly.",
    },
    {
		key: "Capital_and_Operational_Expenditures",
		title: "Capital and Operational Expenditures (CAPEX and OPEX)",
		description:
			"The deployment of basic infrastructure (towers, fiber etc.), the purchase of the required spectrum along with the continuous need for maintenance, which is difficult due to logistical challenges, increase the total cost in rural areas taking into account the limited potential revenue in such areas.",
    },
    {
		key: "Revenue_Uncertainty",
		title: "Revenue Uncertainty",
		description:
			"The limited population density and lower income levels in rural areas lead to uncertainties in generating sufficient revenue from connectivity services, making it harder to attract investments or secure loans for infrastructure deployment.",
    },
];

export const proposalsDataEconomicAspects = [
    {
		key: "Community_Owned_Networks",
		title: "Community-Owned Networks",
		description:
			"Local communities can collaborate in order to deploy and operate their own networks/infrastructure. In this manner, costs are shared between the communities while generated revenue stays in the communities.",
    },
    {
		key: "Funding_opportunities",
		title: "Funding Opportunities",
		description:
			"An additional Guideline for funding opportunities is provided apart.",
    },
    {
		key: "Government_Subsidies",
		title: "Government Subsidies",
		description:
			"Government can also offer direct financial assistance or indirect ones (e.g. tax incentives) to telecom operators or third-parties deploying networks in rural areas.",
    },
    {
        key: "Common_Shared_Infrastructure",
        title: "Common/Shared Infrastructure",
        description:
          "Telecom operators or third-parties can deploy networks using sharing models of the passive (e.g. MORAN) and/or the active infrastructure (e.g. MOCN) reducing thus the cost per operator and improving the coverage.",
    },
];

export const challengesDataTechnicalDeployment = [
    {
		key: "Technology_Choice",
		title: "Technology Choice",
		description:
			"The choice of a technology to provide rural coverage is relevant to the quality and performance of the service that can be provided, impacts in costs for setup and operation, and has an environmental impact. It is not clear which technology is the best option among the available ones.",
    },
    {
		key: "Complexity_of_Large_Scale_Deployment",
		title: "Complexity of Large Scale_Deployment",
		description:
			"The infrastructure to be deployed in order to provide coverage for a region can be very complex. There is a large variety in terms of type of equipment and supported technologies, numbers of base stations to be deployed and other details, depending on the geographical properties of the regions, the sectors and services to be covered, etc.",
    },
    {
		key: "Continuous_Utilization",
		title: "Continuous Utilization",
		description:
			"Once deployed and used by citizens and services, the infrastructure deployment might need to be optimized or extended over time.",
    },
];

export const proposalsDataTechnicalDeployment = [
    {
		key: "Small_Cells_Micro_Towers",
		title: "Small Cells & Micro Towers",
		description:
			"Deploy a mix of large towers and small cells for 4G, 5G, and IoT coverage in rural areas. Use lower-frequency antennas on large towers to expand coverage and reduce costs. Small cells can enhance coverage in sparse or specialized areas. Leverage existing infrastructure where possible. Deployment speeds vary across EU countries.",
    },
    {
		key: "Open_Radio_access_Networks",
		title: "Open Radio Access Networks (RAN)",
		description:
			"Open RAN enables the use of standardized, interoperable hardware and software leading to lower deployment costs while opening the competition.",
    },
    {
		key: "Satellite_Connectivity",
		title: "Satellite Connectivity",
		description:
			"Low earth orbit (LEO) satellites can help in providing the required high-speed internet to remote areas, where regular terrestrial infrastructure cannot reach or it is expensive to be deployed.",
    },
    {
		key: "Microwave_Backhaul_Links",
		title: "Microwave Backhaul Links",
		description: "A cost-effective alternative to fiber in areas where cable deployment is challenging. While less robust than fiber, microwave links offer faster, cheaper deployment. A hybrid approach, combining limited fiber with wireless backhaul, ensures quality connectivity while reducing costs.",
    },
    {
		key: "Scalable_Shareable_Solutions",
		title: "Scalable & Shareable Solutions",
		description: "Deploy scalable infrastructure that adapts to demand and tech advancements. Enable tower, backhaul, and resource sharing while using intelligent systems for service quality monitoring and optimization (e.g., service orchestration, dynamic radio configurations).",
    },
];

export const challengesDataServiceOfferingsandBusinessModels = [
    {
		key: "Sustainability_of_Regional_Deployments",
		title: "Sustainability of Regional Deployments",
		description: "Sustaining regional high-speed connectivity is challenging due to high costs, low revenue, maintenance demands, and rapid technological changes. Environmental impacts and limited local expertise add complexity, requiring innovative and collaborative solutions.",
    },
    {
		key: "Lack_of_Tailored_Service_Offerings",
		title: "Lack of Tailored Service Offerings",
		description: "Service providers may not design packages or solutions tailored to the specific needs of rural communities, such as affordable low-data plans or agriculture-specific IoT services, leading to low adoption rates.",
    },
    {
		key: "Balancing_Public_and_Private_Interests",
		title: "Balancing Public and Private Interests",
		description: "Aligning the profitability goals of private operators with public objectives of digital inclusion and socio-economic development can be complex and lead to misaligned incentives.",
	},
];

export const proposalsDataServiceOfferingsandBusinessModels = [
    {
      key: "Addresing_sustainability_challenges",
      title: "Addresing sustainability challenges",
      description:
        "Deploy a mix of large towers and small cells for 4G, 5G, and IoT coverage in rural areas. Use lower-frequency antennas on large towers to expand coverage and reduce costs. Small cells can enhance coverage in sparse or specialized areas. Leverage existing infrastructure where possible. Deployment speeds vary across EU countries.",
    },
    {
      key: "Initiatives_to_increase_adoption_rates_and_relevance",
      title: "Initiatives to increase adoption rates and relevance",
      description:
        " Service providers can partner with governments, NGOs, and cooperatives to develop affordable digital solutions, such as agriculture-focused IoT. Subsidies, tax breaks, and public-private partnerships lower costs and expand access. Digital education, pilot projects, and flexible payment plans drive adoption, while tailored regulations support rural connectivity and socio-economic growth. These aspects are detailed in BM canvases and the deployment guide.",
    },
    {
      key: "Align_profitability_with_societal_goals",
      title: "Align profitability with societal goals",
      description:
        "Public-private collaborations, inclusive regulations, subsidies, and tiered pricing can balance affordability and profitability. Socio-economic evaluations and community input ensure services meet real needs, while innovation funding and infrastructure sharing enhance rural connectivity. These approaches align public goals and private objectives for equitable digital access.",
    },
];

export const challengesDataSocialChallenges = [
    {
      key: "Engaging_Communities_Digital_Inclusion",
      title: "Engaging Communities & Digital Inclusion",
      description:
        "Rural connectivity must address local needs early by involving stakeholders like farmers and residents. Tailored solutions prevent deepening the digital divide, ensuring equitable access for all, especially marginalized groups. Inclusive planning reduces inequalities and maximizes the benefits of new technologies.",
    },
    {
      key: "Community_Engagement_Digital_Inclusion",
      title: "Community Engagement & Digital Inclusion",
      description:
        "Early engagement with rural stakeholders ensures tailored connectivity solutions. Equitable access is crucial to prevent widening the digital divide and deepening inequalities, ensuring all communities benefit from new technologies.",
    },
    {
      key: "Ensuring_Health_and_Safety_Benefits_of_5G",
      title: "Ensuring Health and Safety Benefits of 5G",
      description:
        "5G enables safer agriculture through autonomous machinery and remote sensors, reducing manual labor and exposure to hazards. Proper implementation is key to fully realizing these benefits.",
    },
    {
        key: "Citizen_Concerns",
        title: "Citizen Concerns",
        description:
          "The deployment of new radio technologies can raise doubts and concerns among citizens with regards to their health, privacy, etc.",
    },
    {
        key: "Lack_of_skills",
        title: "Lack of skills",
        description:
          "Many rural residents lack the digital skills needed to fully use smartphones, laptops, and online services. Language barriers and limited tech familiarity further hinder adoption.",
    },
];

export const proposalsDataSocialChallenges = [
    {
      key: "Infrastructure_planning",
      title: "Infrastructure planning",
      description:
        "To maximize the benefits of 4G and 5G rollout, prioritize job creation, support tech startups, and develop educational programs to build a skilled workforce. Additionally, invest in rural infrastructure and services to stimulate growth while planning sustainable urban development to balance migration impacts.",
    },
    {
      key: "Engage_Local_Communities_and_Promote_Digital_Inclusivity",
      title: "Engage Local Communities and Promote Digital Inclusivity",
      description:
        "Involve local communities, including marginalized farmers, in technology planning to address their connectivity needs. Provide training to ensure effective use and prioritize equitable access to prevent digital exclusion and reduce inequalities. This ensures relevant, inclusive, and sustainable solutions.",
    },
    {
      key: "Long_term_Digital_Education",
      title: "Long-term Digital Education",
      description:
        "Promote digital literacy and technology adoption in rural areas through dedicated programs. Address public concerns by transparently communicating research on cellular technology safety, providing clear, evidence-based information to build trust.",
    },
];

export const challengesDataEnvironmentalConsiderations = [
    {
      key: "Local_Ecosystems",
      title: "Local Ecosystems",
      description:
        "The widespread deployment of cellular infrastructure in rural areas could disrupt local ecosystems, making it essential to consider land management practices.",
    },
    {
      key: "5G_Energy_Consumption",
      title: "5G Energy Consumption",
      description:
        "As 5G networks require much less energy to transmit the same data as 4G, they are more efficient in the ratio of power consumption to traffic. However, 5Gs higher speed and bandwidth might also increase the total number of devices using the network extensively – this could become a problem as energy consumption increases.",
    },
    {
      key: "Exposure_to_Electromagnetic_Fields",
      title: "Exposure to Electromagnetic Fields",
      description:
        "An electromagnetic field (EMF) is a physical field produced by stationary, spinning or moving electrically charged particles. Electric and magnetic fields also exist in nature. However, as the number of smartphones, tablets, laptops and many other connected devices increase, it has raised concerns about how EMF exposure might affect our health.",
    },
];

export const proposalsDataEnvironmentalConsiderations = [
    {
      key: "Environmental_Assessments_Planning",
      title: "Environmental Assessments & Planning",
      description:
        "Smart agriculture requires careful infrastructure planning to minimize environmental impact. Use life cycle assessments (LCA) and GIS to identify suitable locations for base stations, balancing technological needs with ecological preservation.",
    },
    {
      key: "Infrastructure_Sharing",
      title: "Infrastructure Sharing",
      description:
        " Prioritize the adoption of shared infrastructure models for 5G technologies. Beyond their economic advantages, shared infrastructures can significantly mitigate environmental and visual impacts by optimizing the number of sites required and minimizing the visual footprint of network expansion. ",
    },
    {
      key: "Respect_the_Radiation_Limits",
      title: "Respect the Radiation Limits",         
      description:
        "5G infrastructure deployment should account for potential impacts on biodiversity. Studies indicate RF-EMF exposure may affect various species. Adhering to ICNIRP guidelines ensures human safety while minimizing environmental risks.",
      image: "/images/mappopup.png", 
    },
    {
        key: "Eco_Friendliness",
        title: "Eco-Friendliness",
        description:
          `Eco-design principles should be applied to system architecture and software development, helping to make solutions and equipment more energy efficient and reach a longer life cycle. Solutions like autonomous small cells powered by photovoltaics and power reduction policies ("sleep mode") should be implemented.`,
      },
];


export const regionalPopupcontent = {
    Limited_Spectrum_Availability: `The availability of private spectrum in different countries (2024) for the implementation of private networks. An additional, detailed report is available from EUWENA: <a href="https://static1.squarespace.com/static/618d27c76b02e03d13069543/t/657a2bf03c363b76fb65d846/1702505457227/Spectrum+Update+2023.pdf" target="_blank">Spectrum Update 2023</a>`, 
    Encourage_Infrastructure_Sharing: `
        <p>
        The European Commission emphasizes efficient spectrum utilization through shared use, allowing multiple users to access the same frequency bands under specific conditions. This approach aims to meet the increasing demand for wireless services while avoiding harmful interference.
        <a href="https://digital-strategy.ec.europa.eu/en/policies/shared-use-spectrum" target="_blank">Read more</a>.
        </p>
        <p>
        This white paper focuses on access to temporarily licensed shared spectrum for local private networks. It discusses optimizing spectrum sharing efficiency and supporting flexibility and dynamic spectrum demand through automated access procedures tailored to specific use cases.
        <a href="https://www.etsi.org/images/files/ETSIWhitePapers/ETSI-WinnForum-WPSpectrum_sharing_frameworks_for_temporary_dynamic_and_flexible_spectrum_access_for_local_private_networks.pdf" target="_blank">Download White Paper</a>.
        </p>
    `,
    Regulator_Support: `
        <p>
            The European Users Wireless Enterprise Network Association (EUWENA) is actively working to broaden and facilitate access to private frequencies for European businesses. Their objective is to enable companies to deploy their own private cellular networks, thereby accelerating digital transformation across various industries. EUWENA advocates for the harmonization of private 5G radio frequencies at the European level to reduce deployment costs and foster innovation.
        </p>
        <p>
            <a href="https://www.transatel.com/wp-content/uploads/2023/11/Spectrum-availability-the-key-to-Private-5G-Networks-adoption.pdf" target="_blank">Read the full report here</a>.
        </p>
    `,
    Funding_opportunities: `The XGain <a href="/documents/guide_to_local_broadband_deployment.pdf" target="_blank">guidelines</a> for deployments includes information about funding possibilites`,
    Common_Shared_Infrastructure: `Concepts like MOCN and MORAN, and other ways of sharing infrastructure are explained in the XGain technical <a href="/documents/technological_handbook.pdf" target="_blank">guidelines</a>`,
    Small_Cells_Micro_Towers:  `
        <p>
            The <a href="https://digital-strategy.ec.europa.eu/en/policies/5g-observatory" target="_blank">5G Observatory</a> captures the deployment profiles across Europe.
        </p>
        <p>
            In June 2020, the European Commission adopted the Implementing Regulation on small-area wireless access points, commonly known as small cells. This regulation specifies the physical and technical characteristics of small cells and aims to simplify and accelerate 5G network installations by exempting these installations from individual planning permits, provided they meet certain criteria. The goal is to facilitate the timely deployment of 5G networks by reducing administrative barriers.
        </p>
        <p>
            <a href="https://digital-strategy.ec.europa.eu/en/library/commission-report-status-implementing-rules-small-cells-deployment" target="_blank">Read the full Commission report here</a>.
        </p>
    `,
    Open_Radio_access_Networks:`
        <p>
        O-RAN is on the steady rise, and initiatives like <a href="https://www.gsma.com/solutions-and-impact/gsma-open-gateway/" target="_blank">Open Gateway</a> are fostering open-source programming interfaces to enable novel services and business models.
        </p>
        <p>
        Learn more about <a href="https://digital-strategy.ec.europa.eu/en/library/commission-publishes-study-future-5g-supply-ecosystem-europe" target="_blank">O-RAN deployments and supply market trends</a>.
        </p>
    `,
    Addresing_sustainability_challenges: 
    `
      <p>Regional BM Canvas for Authorities</p>
      <img src="/images/business-model-icons/bmEndUserISPs.png" width="100%">
      <img src="/images/business-model-icons/bmPublicAuthorities.png" width="100%" style="margin-top: 20px"">
    `,
    Initiatives_to_increase_adoption_rates_and_relevance: 
     `
      <p>Regional BM Canvas for Authorities</p>
      <img src="/images/business-model-icons/bmEndUserISPs.png" width="100%">
      <img src="/images/business-model-icons/bmPublicAuthorities.png" width="100%" style="margin-top: 20px"">
    `,
    Engage_Local_Communities_and_Promote_Digital_Inclusivity :  `
        <p>
            The EU offers several initiatives and plans to increase digital literacy and foster digital education:
        </p>

        <p>
            <strong>Digital Education Action Plan (2021-2027):</strong>  
            This EU policy initiative aims to support the adaptation of education and training systems to the digital age. It focuses on high-quality, inclusive, and accessible digital education, addressing challenges and opportunities arising from the COVID-19 pandemic.  
            <a href="https://education.ec.europa.eu/focus-topics/digital-education/action-plan" target="_blank">Learn more about the Digital Education Action Plan</a>.
        </p>

        <p>
            <strong>Digital Skills and Competences:</strong>  
            The EU has set ambitious targets to ensure that 80% of adults possess at least basic digital skills by 2030 and to reach 20 million employed ICT specialists. This initiative promotes access to digital skills for all, with a particular emphasis on women and increasing the number of ICT graduates.  
            <a href="https://digital-strategy.ec.europa.eu/en/policies/digital-skills" target="_blank">Explore the Digital Skills and Competences initiative</a>.
        </p>

        <p>
            <strong>Digital Inclusion Efforts:</strong>  
            Digital inclusion is a priority for the EU, aiming to ensure that everyone can contribute to and benefit from the digital world. This includes efforts to reduce the digital divide and promote digital literacy among all citizens.  
            <a href="https://digital-strategy.ec.europa.eu/en/policies/digital-inclusion" target="_blank">Read about Digital Inclusion efforts</a>.
        </p>
    `,
    Long_term_Digital_Education :  `
        <p>
        The EU offers several initiatives and plans to increase digital literacy and foster digital education:
        </p>

        <p>
        <strong>Digital Education Action Plan (2021-2027):</strong>  
        This EU policy initiative aims to support the adaptation of education and training systems to the digital age. It focuses on high-quality, inclusive, and accessible digital education, addressing challenges and opportunities arising from the COVID-19 pandemic.  
        <a href="https://education.ec.europa.eu/focus-topics/digital-education/action-plan" target="_blank">Learn more about the Digital Education Action Plan</a>.
        </p>

        <p>
        <strong>Digital Skills and Competences:</strong>  
        The EU has set ambitious targets to ensure that 80% of adults possess at least basic digital skills by 2030 and to reach 20 million employed ICT specialists. This initiative promotes access to digital skills for all, with a particular emphasis on women and increasing the number of ICT graduates.  
        <a href="https://digital-strategy.ec.europa.eu/en/policies/digital-skills" target="_blank">Explore the Digital Skills and Competences initiative</a>.
        </p>

        <p>
        <strong>Digital Inclusion Efforts:</strong>  
        Digital inclusion is a priority for the EU, aiming to ensure that everyone can contribute to and benefit from the digital world. This includes efforts to reduce the digital divide and promote digital literacy among all citizens.  
        <a href="https://digital-strategy.ec.europa.eu/en/policies/digital-inclusion" target="_blank">Read about Digital Inclusion efforts</a>.
        </p>
    `,
    Respect_the_Radiation_Limits: `
        <p>
        The map shows the limits for electromagnetic exposure:  
        <a href="https://www.eea.europa.eu/en/analysis/maps-and-charts/overview-of-limits-for-exposure?activeTab=a7caf3b5-7254-4a24-8919-693d4115158b" target="_blank"><strong>View the Map</strong></a>
        </p>
    `,
    Eco_Friendliness: `
        <p>
        An outlook for the EU Solar Power Market shows the current status and challenges that must be addressed, with policy-making being one of the key challenges.  
        <a href="https://www.solarpowereurope.org/insights/outlooks/eu-market-outlook-for-solar-power-2024-2028/detail" target="_blank"><strong>Read the EU Market Outlook for Solar Power (2024-2028)</strong></a>.
        </p>

        <p>
        A discussion on current trends, challenges, and opportunities arising from the solar market.  
        <a href="https://www.eupd-research.com/en/european-solar-market-2024-2025-balancing-growth-challenges-and-opportunities" target="_blank"><strong>Explore the European Solar Market (2024-2025)</strong></a>.
        </p>
    `
};